import React from 'react';
import './terms.css'; // Custom CSS for styling
import { useNavigate } from 'react-router-dom';
import GameHeader from '../header/header';
import Image4 from "../../Assets/images/certificate.jpg"

const Certificate = () => {
    const navigate = useNavigate();

    const handleAdminlogin = () => {
        window.history.back();
        // navigate(`/`);
    };
    return (
        <div className="obtibg">
            <GameHeader />
            <div className="terms-container">
                <div className="terms-content">
                    <h1>Certificate</h1>
                    <img src={Image4} className='w-100' />
                </div>
            </div>
        </div>
    );
};

export default Certificate;
